<p-dialog header="Make a Payment" *ngIf="displayPaymentDialog" [(visible)]="displayPaymentDialog" [responsive]="true" [modal]="true"
          [style]="DialogStyle500x650" (onHide)="onClickCancelPaymentDialog()"
          [dismissableMask]="false" [closable]="false">

  <div class="instruction-text">
    You are about to make a payment for {{paymentDialogRequest.receiverName}}
  </div>

  <form #dialogForm="ngForm">

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>Receiver Name </label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        {{paymentDialogRequest.receiverName}}
      </div>
    </div>


    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>Amount to Pay </label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        {{paymentDialogRequest.paymentAmount | currency:Format.Currency}}
      </div>
    </div>

    <div class="p-col-12 alert alert-danger" *ngIf="displayTransactionExceedsLimitMsg">
      {{transactionExceedsLimitMsg}}
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>Payment Type</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        <p-dropdown [(ngModel)]="paymentType" [options]="paymentTypeDropdown" filter="true" name="txnType"
                    (onChange)="onChangePaymentType(paymentType)"
                    [placeholder]="Validation.DropdownPlaceholder" required>
        </p-dropdown>
      </div>
    </div>


    <div class="p-grid" *ngIf="paymentType == PaymentType.ManualCheck || paymentType == PaymentType.Check">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label for="checkOrReferenceNumber">Override Check #</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        <input type="text" pInputText id="checkOrReferenceNumber" name="checkOrReferenceNumber" [(ngModel)]="overRideCheckOrReferenceNumber">
      </div>
    </div>


    <div *ngIf="paymentType == PaymentType.ACH || paymentType == PaymentType.Check">
      <label>Source Account Details </label>
      <app-ach-select-funding-source [request]="orgFundingSource" *ngIf="orgFundingSource"
                                     (selectedFundingSourceEvent)="onSelectOrgFundingSource($event, paymentType)"></app-ach-select-funding-source>

      <div *ngIf="paymentType == PaymentType.ACH">
        <label>Destination Account Details</label>
        <app-ach-select-funding-source [request]="destinationFundingSource" *ngIf="destinationFundingSource"
                                       (selectedFundingSourceEvent)="onSelectDestinatioFundingSource($event)"></app-ach-select-funding-source>
      </div>
    </div>

  </form>

  <p-footer>
    <div style="margin:10px 10px 0 0;">
      <button class="button-inaction" pButton (click)="onClickCancelPaymentDialog()" icon="fa fa-close" type="button" label="Cancel"></button>
      <button class="button-action" icon="fa fa-check" pButton (click)="onClickMakePayment()" type="button" label="Pay"
              [disabled]="disablePayment || !dialogForm.valid
                || (paymentType == PaymentType.ACH && (!sourceAch || !destinationAch))
                || (paymentType == PaymentType.Check &&  !achForCheckPayment?.id)
                || (paymentType == PaymentType.ManualCheck && !overRideCheckOrReferenceNumber)"></button>
    </div>
  </p-footer>

</p-dialog>
